"use client";

import { cn } from "@/lib/utils";
import type { LegalDoc } from "./types";

export function LegalTabs({
  docs,
  activeSlug,
  onSelect,
}: {
  docs: readonly LegalDoc[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}) {
  return (
    <div className="border-b border-gray-200 sticky top-0 z-10 bg-white/95 backdrop-blur">
      <div className="max-w-6xl mx-auto px-6">
        <nav
          className="-mx-6 px-6 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          aria-label="Legal documents"
        >
          <ul className="flex gap-1 whitespace-nowrap min-w-max">
            {docs.map((doc) => {
              const active = doc.slug === activeSlug;
              return (
                <li key={doc.slug}>
                  <button
                    type="button"
                    onClick={() => onSelect(doc.slug)}
                    className={cn(
                      "relative px-4 py-4 text-sm font-medium transition-colors",
                      active
                        ? "text-blue-600"
                        : "text-gray-600 hover:text-gray-900",
                    )}
                    aria-current={active ? "page" : undefined}
                  >
                    {doc.title}
                    <span
                      className={cn(
                        "absolute left-0 right-0 -bottom-px h-0.5 transition-colors",
                        active ? "bg-blue-600" : "bg-transparent",
                      )}
                    />
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}
